<template>
  <div>
    <!-- Header -->
    <div v-if="this.var === 'CClimad'" class="columns header">
      <div class="column is-one-third title-header">
        <span>
          Priorización
        </span>
      </div>
      <div class="column is-one-fifth">
        <div class="ranking ranking-only-icon">
          <img
            src="@/assets/icons/ranking-linear.svg"
            alt="rankingIconCL7"
            width="60"
          />
          <div class="info">
            <span class="subtitle-ranking">
              Entre
              <strong>{{ generalContext.headers.clients || 0 }}</strong>
              Empresas
            </span>
          </div>
        </div>
      </div>
      <div class="column title-header">
        <span>
          Benchmark
        </span>
      </div>
    </div>
    <hr v-if="this.var === 'CClimad'" />
    <div v-if="data" class="columns has-text-centered">
      <!-- Column Titles -->
      <div class="column is-one-third col-titles">
        <!-- Title Data -->
        <div>
          <div
            class="heading is-size-6 border"
            :class="`bg${range(data.p)}`"
            style="padding: 6px 0; margin-top: 15px; min-height: 38px;"
          >
            <div v-if="this.var !== 'CClimad'" class="columns">
              <!-- Icon -->
              <div class="column is-2">
                <i
                  class="material-icons has-text-white icon-dash"
                  v-tooltip.top="'Ver más'"
                  v-on:click="switchSubGroups()"
                  v-if="items"
                  style="cursor: pointer;"
                >
                  {{ active ? "remove_circle_outline" : "add_circle_outline" }}
                </i>
              </div>
              <!-- Text -->
              <div class="column titleC">
                {{ title }} {{ data ? data.p : 0 | number1(1) }}%
              </div>
              <div
                v-tooltip.top="{
                  content: createBodyTooltipInter(),
                  classes: 'contentTooltipInter',
                }"
                class="column is-2"
                v-on:click="getDataInter(data)"
              >
                <i
                  class="material-icons has-text-white icon-dash"
                  style="cursor: pointer;"
                >
                  info
                </i>
              </div>
              <div v-if="this.var === 'CClimad'" class="column is-2"></div>
            </div>
            <div
              v-if="this.var === 'CClimad'"
              class="is-flex is-justify-between"
              style="margin: 0 20px 0 20px;"
            >
              <span class="titleC"> {{ title }}</span>
              <span>{{ data ? data.p : 0 | number1(1) }}%</span>
            </div>
          </div>
        </div>
        <!-- Title Target -->
        <div
          v-if="dataTarget && Object.keys(dataTarget).length"
          class="content-historic"
        >
          <div
            class="heading is-size-6 border"
            :class="`bg${range(dataTarget.p)}`"
            style="padding: 5px; min-height: 38px;"
          >
            <div v-if="this.var !== 'CClimad'" class="columns">
              <!-- Icon -->
              <div class="column is-2"></div>
              <!-- Text -->
              <div class="column titleC">
                {{ title }}
                {{ dataTarget ? dataTarget.p : 0 | number1(1) }}%
              </div>
              <div
                v-tooltip.top="{
                  content: createBodyTooltipInter(),
                  classes: 'contentTooltipInter',
                }"
                class="column is-2"
                v-on:click="getDataInter(dataTarget)"
              >
                <i
                  class="material-icons has-text-white icon-dash"
                  style="cursor: pointer;"
                >
                  info
                </i>
              </div>
              <div v-if="this.var === 'CClimad'" class="column is-2"></div>
            </div>
            <div
              v-if="this.var === 'CClimad'"
              class="is-flex is-justify-between"
              style="margin: 0 20px 0 20px;"
            >
              <span class="titleC"> {{ title }}</span>
              <span>{{ dataTarget ? dataTarget.p : 0 | number1(1) }}%</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Columns Graph -->
      <div class="column" style="margin: auto;">
        <div class="col-graph">
          <div class="ranking" style="width: 20%;">
            <div
              class="info"
              style="width: 100%;"
              v-tooltip.bottom="'Posición actual frente al total de empresas'"
            >
              <span class="title-ranking card-position">
                {{ getPositionVar(this.data, this.var) }}
              </span>
            </div>
          </div>
          <GraphChartJs
            v-if="validateDataGraph(data)"
            :config="createdGraph(data)"
            :cambio="change"
            style="height: 100px !important; width: 500px;"
          />
        </div>
      </div>
    </div>

    <!-- Only Title -->
    <div v-if="!data && title">
      <div
        style="margin-bottom: 15px; margin-top: 15px;"
        class="is-flex is-justify-center"
      >
        <hr class="has-text-dark" style="width: 20%" />
        <h1
          class="title is-size-4"
          style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
        >
          {{ title }}
        </h1>
        <hr class="has-text-dark" style="width: 20%" />
      </div>
    </div>
    <hr />
  </div>
</template>
<script>
import json from "../interpretaciones.json";
import GraphChartJs from "../../dashboard/GraphChartJs.vue";

export default {
  data() {
    return {
      interpretations: json,
      horizontalBar: {
        type: "horizontalBar",
        options: {
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
          },
          hover: {
            animationDuration: 0,
          },
          tooltips: {
            enabled: false,
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  display: false,
                },
                scaleLabel: {
                  display: false,
                },
                gridLines: {
                  display: false,
                },
                stacked: true,
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: false,
                },
                ticks: {
                  display: false,
                  beginAtZero: true,
                  max: 100,
                },
                stacked: true,
              },
            ],
          },
          legend: {
            position: "top",
            display: false,
          },
          animate: {},
          pointLabelFontFamily: "Quadon Extra Bold",
          scaleFontFamily: "Quadon Extra Bold",
          responsive: true,
          resizeDelay: 0,
          plugins: {
            datalabels: {
              formatter: function(value, context) {
                return `${value}%`;
              },
              textAlign: "start",
            },
          },
        },
        data: {
          labels: ["Data 1"],
          datasets: [
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
          ],
        },
      },
      rangeColors: ["#76be7c", "#d9ead3", "#fde8af", "#f5bc95", "#fda0a0"],
      colors: {
        "Muy alto": "#045a8d",
        Alto: "#0570b0",
        Medio: "#3690c0",
        Bajo: "#74a9cf",
        "Muy bajo": "#a6bddb",
      },
    };
  },
  props: {
    group: String,
    var: String,
    title: String,
    change: Number,
    data: Object,
    dataTarget: {
      type: Object || null,
      default() {
        return null;
      },
    },
    generalContext: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      default() {
        return false;
      },
    },
    items: {
      type: Boolean,
      default() {
        return null;
      },
    },
    ranges: Function,
  },
  mounted() {
    // console.log(this.dataTarget);
    // console.log(this.active);
    // console.log(this.data, this.title);
  },
  methods: {
    createdGraph(data) {
      try {
        if (!data && !Object.keys(this.generalContext.data).length) return null;

        const position = data.p;
        const context = Object.entries(this.generalContext.data[this.var]);
        const labels = context.map(([k, v]) => parseInt(k));
        const colors = labels.map((v) => this.getInfoRange(v));

        return {
          type: "line",
          data: {
            datasets: [
              {
                label: "Empresas",
                data: context.map(([k, v]) => {
                  return { x: Number(k), y: Number(v) };
                }),
                fill: false,
                color: colors,
                backgroundColor: colors,
                borderColor: "rgb(75, 192, 192)",
                tension: 0.2,
                pointRadius: function(context) {
                  const dataIndex = context.dataIndex;
                  const dataset = context.dataset.data;

                  // if (dataIndex === 0 || dataIndex === dataset.length - 1) {
                  //   return 4;
                  // }

                  const value = dataset[dataIndex].y;
                  return value === 0 ? 0 : 4;
                },
              },
            ],
          },
          options: {
            tooltips: {
              callbacks: {
                title: function(tooltipItem, data) {
                  const value = tooltipItem[0].label;
                  const valueRange = this.getInfoRange(value, "range");
                  return `${this.getInfoRange(value, "title")} (${
                    valueRange[0]
                  }% al ${valueRange[1]}%)`;
                }.bind(this),
              },
            },
            legend: { display: false, position: "right" },
            responsive: true,
            maintainAspectRatio: false,
            resizeDelay: 0,
            scales: {
              yAxes: [
                {
                  ticks: {
                    stepSize: 1,
                    beginAtZero: true,
                    padding: 0,
                  },
                  gridLines: {
                    display: true,
                  },
                },
              ],
              xAxes: [
                {
                  type: "linear",
                  ticks: {
                    stepSize: 5,
                    min: Math.min(...labels),
                    max: Math.max(...labels),
                    autoSkip: false,
                    display: false,
                  },
                  gridLines: {
                    display: false,
                  },
                },
              ],
            },
            annotation: {
              annotations: [
                {
                  id: "a-line-1",
                  type: "line",
                  mode: "vertical",
                  scaleID: "x-axis-0",
                  value: position.toFixed(2),
                  borderColor: "rgba(0, 0, 0, 0.5)",
                  borderWidth: 2,
                  labelEnabled: true,
                  imagenStatus: false,
                  label: {
                    enabled: true,
                    content: ".",
                    position: "top",
                    fontColor: "#FFFFFF",
                    fontSize: 14,
                    fontStyle: "bold",
                    fontFamily: "Arial",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    xPadding: 10,
                    yPadding: 0,
                    yAdjust: 0,
                    cornerRadius: 5,
                  },
                },
              ],
            },
          },
          plugins: [
            {
              beforeDraw: (chart) => {
                const ctx = chart.chart.ctx;

                const xScale = chart.scales["x-axis-0"];
                const yScale = chart.scales["y-axis-0"];

                xScale.ticks.forEach((tick, index) => {
                  const tickX = xScale.getPixelForTick(index);
                  ctx.fillStyle = this.getInfoRange(tick);
                  const tickWidth =
                    index < xScale.ticks.length - 1
                      ? xScale.getPixelForTick(index + 1) - tickX
                      : xScale.right - tickX;

                  ctx.fillRect(tickX, yScale.bottom, tickWidth, 20);
                });
              },
              afterDatasetsDraw: (chart) => {
                const ctx = chart.ctx;
                const sizeImg = 30;
                // Recorre las anotaciones y dibuja la imagen
                Object.entries(chart.annotation.elements).forEach(
                  ([key, annotation]) => {
                    if (annotation.options.type !== "line") return;

                    const model = annotation._model;

                    if (!model || isNaN(model.x1) || isNaN(model.y1)) return;

                    if (annotation.options.imagenStatus) {
                      ctx.drawImage(
                        annotation.options.img,
                        model.x1 - sizeImg / 2,
                        model.y1 - 8,
                        sizeImg,
                        sizeImg
                      );
                    }

                    // Dibuja una imagen junto al texto de la anotación
                    const img = new Image();
                    img.src = require("@/assets/icons/companyDefault.png");
                    img.onload = () => {
                      annotation.options.img = img;
                      ctx.drawImage(
                        img,
                        model.x1 - sizeImg / 2,
                        model.y1 - 8,
                        sizeImg,
                        sizeImg
                      ); // Dibuja la imagen en el gráfico
                      annotation.options.imagenStatus = true;
                    };
                  }
                );
              },
            },
          ],
        };
      } catch (error) {
        console.log(error);
      }
    },
    validateDataGraph(data) {
      console.log(data);

      return !!data;
    },
    createBodyTooltipInter() {
      const group = this.group;
      const sub = this.var;
      if (!group) {
        return `<div><h2 class='has-text-centered is-size-5 has-text-weight-bold'>${this.interpretations[sub].title}</h2><br><p>${this.interpretations[sub]["def"]}</p><br></div>`;
      } else if (group) {
        return `<div><h2 class='has-text-centered is-size-5 has-text-weight-bold'>${this.interpretations[group].dimensiones[sub].title}</h2><br><p>${this.interpretations[group].dimensiones[sub]["def"]}</p>
            <br><span class='is-size-7 has-text-weight-bold'>Clic para ver más.</span></div>`;
      } else {
        return `<div><h2 class='has-text-centered is-size-5 has-text-weight-bold'>Error en los datos</h2><br><p>Revisa porfavor que los datos estes subidos correctamente, posiblemente el nombre de la columna de este dato no se ingreso correctamente.</p><br><span class="has-text-weight-bold">Erro en el dato</span></div>`;
      }
    },
    getDataInter(data) {
      if (this.group) {
        const allData = {
          ...data,
          group: this.group,
          subGroup: this.var,
          title: this.title,
          active: this.active,
          color: this.rangeColors[this.range(data.p)],
          type: 1,
        };
        this.$emit("openMenuInter", allData);
      }
    },
    getPositionVar(data, subgroup) {
      const value = data.p;
      if (value === null) return "-";
      subgroup = subgroup.toLowerCase();
      const position = this.generalContext.headers.ranking[
        `${subgroup}_p`
      ].filter((item) => item[`${subgroup}_p`] > value).length;
      return position + 1;
    },
    switchSubGroups() {
      this.$emit("switchSubGroups", this.var);
    },
    calculatePorcentage(v, sum) {
      return ((v * 100) / sum).toFixed(1);
    },
    getInfoRange(value, type = "color") {
      const ranges = [
        {
          range: [0, 15], // Es 16 pero se acomoda a 15 para que se pnga en puntos de 5 en 5
          color: "#fda0a0",
          title: "Actuemos ya",
        },
        {
          range: [15, 30],
          color: "#f5bc95",
          title: "Necesita atención pronto",
        },
        { range: [30, 70], color: "#fde8af", title: "Cuidado" },
        { range: [70, 84], color: "#d9ead3", title: "Vamos bien" },
        { range: [84, 100], color: "#76be7c", title: "Sigamos así" },
      ];
      const rangeObject = ranges.find(({ range }) => value < range[1]);
      return rangeObject ? rangeObject[type] : null;
    },
    range(p) {
      return this.ranges(p);
    },
  },
  components: {
    GraphChartJs,
  },
};
</script>

<style lang="scss" scoped>
.titleC {
  margin: auto;
  text-overflow: ellipsis !important;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  display: inline-block;
  text-transform: initial;
}

.onlyTitle {
  border: solid 1px rgba(65, 64, 64, 0.91);
  text-align: center;
}

.content-historic {
  opacity: 0.5;
}
.content-historic .titleC {
  font-size: 14px !important;
}
.content-historic .material-icons {
  font-size: 18px !important;
}

.contentTooltipInter {
  max-width: 20% !important;
  min-width: 10% !important;
}

.tooltip {
  z-index: 55 !important;
}

.bg1 {
  background-color: #76be7c !important;
  // border: solid 1px #4b9e52;
  color: white !important;
}

.bg2 {
  background-color: #d9ead3 !important;
  // border: solid 1px rgb(91, 185, 99);
  color: rgba(65, 64, 64, 0.91);
}

.bg3 {
  background-color: #fde8af !important;
  // border: solid 1px #f8d166;
  color: rgba(65, 64, 64, 0.91);
}

.bg4 {
  background-color: #f5bc95 !important;
  // border: solid 1px #f4aa79;
  color: rgba(65, 64, 64, 0.91);
}

.bg5 {
  background-color: #fda0a0 !important;
  // border: solid 1px #f97a7a;
  color: rgba(65, 64, 64, 0.91);
}

.bg0 {
  background-color: rgba(175, 174, 174, 0.8);
  // border: solid 1px rgba(117, 117, 117, 0.8);
  color: rgba(65, 64, 64, 0.91);
}

// Color icons
.bg1 .icon-dash {
  background-color: #4b9e526b !important;
  border-radius: 25%;
  margin: 3px !important;
  padding: 2px !important;
}

.bg2 .icon-dash {
  background-color: rgba(121, 185, 126, 0.35) !important;
  border-radius: 25%;
  margin: 3px !important;
  padding: 2px !important;
}

.bg3 .icon-dash {
  background-color: #f8d166a5 !important;
  border-radius: 25%;
  margin: 3px !important;
  padding: 2px !important;
}

.bg4 .icon-dash {
  background-color: #f4aa7982 !important;
  border-radius: 25%;
  margin: 3px !important;
  padding: 2px !important;
}

.bg5 .icon-dash {
  background-color: #f97a7a94 !important;
  border-radius: 25%;
  margin: 3px !important;
  padding: 2px !important;
}

.bg0 .icon-dash {
  background-color: rgba(65, 64, 64, 0.35);
  border-radius: 25%;
  margin: 3px !important;
  padding: 2px !important;
}

.border {
  border-collapse: collapse;
  border-radius: 6px;
  overflow: hidden;
}

.message {
  background-color: #fafafa;
}

.title-white {
  color: white !important;
  font-weight: 700 !important;
}

.heading {
  overflow: visible;
}

.header .title-header {
  display: flex;
  align-items: flex-end;
  margin-bottom: 0 !important;
  font-size: 20px;
  color: #363636;
  font-weight: 700;
}

.header .title-header > span {
  background-color: #f3f3f3;
  border-radius: 6px;
  padding: 5px;
  width: 100%;
}

.col-titles {
  gap: 15px;
  display: flex;
  flex-direction: column;
  margin: auto;
}

.col-graph {
  gap: 4rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 30px !important;
  padding-top: 0.6% !important;
}

.ranking {
  display: flex;
  justify-content: start;
  gap: 15px;
}

.ranking-only-icon {
  align-items: center;
  flex-direction: column;
  justify-content: center !important;
}

.ranking .info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ranking .title-ranking {
  color: #363636;
  text-align: center;
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 1.125;
}
.card-position {
  width: 100px;
  height: 100px;
  color: #4a4a4a;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ranking .subtitle-ranking {
  line-height: normal;
}
</style>

<style lang="scss">
.contentTooltipInter {
  max-width: 20% !important;
  min-width: 10% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/graphCtxResult.vue